import moment from 'moment';
import 'moment-timezone';
import { crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
// languageFields is an array with fields names without the suffix portion for language, but keeping suffix portion for type. 
// Suffix (language+type) can be one of these: _en_s _en_t en_html _fr_s _fr_t _fr_html
//     For example name_s would be the input expected for a content type having fields name_en_s and name_fr_s.
// Other possible input are fields in a repeating group. In that case we are going to use notation group.field_name
//     For example names_o.name_s would be the input for fields name_en_s and name_fr_s inside of repeating group names_o
// Other possible input are fields under a child content (grandchild field,  not in repeating group).  
//  In this case we will use secondLevelField;field_name
//     For example lastVideos;title_t would be the input for fields title_en_t and tiel_fr_t inside of child field lastVideos

export function languagePicker(item, languageFields) {
	let cookies=[];
	cookies.lang = getCookie("lan");

	let hasDescriptorDom = false
	if (item.descriptorDom) {
		hasDescriptorDom = true;
	}

	let typeC = "page";
	if ((hasDescriptorDom && item.descriptorDom.component) || (!hasDescriptorDom && item.component)) {
		typeC = "component";
	}

	for (let index in languageFields) {
		
		let field = languageFields[index];
		
		// Is the field in a repeating group?
		let fieldGroup = "";
		let gPos = field.indexOf(".");
		let isRepeatingGroup = (gPos >= 0);
		if (isRepeatingGroup) {
			fieldGroup = field.substring(0, gPos);
			field = field.substring(gPos+1);
		}

		// Is the a grandchild field (second level not in item)?
		let secondLevelField = "";
		let slfPos = field.indexOf(";");
		let isGrandchildField = (slfPos >= 0);
		if (isGrandchildField) {
			secondLevelField = field.substring(0, slfPos);
			field = field.substring(slfPos+1);
		}

		// Gets final field language name
		let tPos = field.lastIndexOf("_");
		let fieldName = field.substring(0, tPos);
		let fieldLangName =  fieldName + "_" + cookies.lang + field.substring(tPos);

		// Set the value according to the selected language to a field without suffix
		if (isRepeatingGroup) {

			let rgItems;

			if (hasDescriptorDom && item.descriptorDom[typeC][fieldGroup]) {
				rgItems = item.descriptorDom[typeC][fieldGroup].item;
			}
			else if (!hasDescriptorDom && item[typeC][fieldGroup]) {
				rgItems = item[typeC][fieldGroup].item;
			}

			if (rgItems) {
				for(let rgIndex in rgItems) {
					if (hasDescriptorDom) {
						item.descriptorDom[typeC][fieldGroup]["item"][rgIndex][fieldName] = item.descriptorDom[typeC][fieldGroup]["item"][rgIndex][fieldLangName];
					}
					else {
						item[typeC][fieldGroup]["item"][rgIndex][fieldName] = item[typeC][fieldGroup]["item"][rgIndex][fieldLangName];
					}
				}
			}
		}
		else if(isGrandchildField) {
			if (hasDescriptorDom && item.descriptorDom[typeC][secondLevelField]) {
				item.descriptorDom[typeC][secondLevelField][fieldName] = item.descriptorDom[typeC][secondLevelField][fieldLangName];
			}
			else if (item[typeC][secondLevelField]) {
				item[typeC][secondLevelField][fieldName] = item[typeC][secondLevelField][fieldLangName];
			}
		}
		else{
			if (hasDescriptorDom) {
				item.descriptorDom[typeC][fieldName] = item.descriptorDom[typeC][fieldLangName];
			}
			else{
				item[typeC][fieldName] = item[typeC][fieldLangName];
			}
		}
	}
	return item;
}

// Return Language based on Cookie
export function getLanguage() {
	let cookies=[];
	cookies.lang = getCookie("lan");

	return cookies.lang;
}

// Return Cookie based on key
export function getCookie(key) {
	let cookies = document.cookie ? document.cookie.split('; ') : [];
	for (let i = 0; i < cookies.length; i++) {
	  let parts = cookies[i].split('=');
	  let foundKey = parts[0];
	  if (key === foundKey) {
		return parts[1];
	  }
	}
	return null;
}

export function isCookieLawSetup() {
	return (document.cookie.indexOf('cpac_2019_mcookie_yes=') !== -1 
		|| document.cookie.indexOf('cpac_2019_mcookie_no=') !== -1)
}

export function setCookieLaw(accepted) {
	let name = "cpac_2019_mcookie_" 
	name += (accepted)? "yes": "no"
	let date = new Date();
	date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
	let expires = "; expires=" + date.toGMTString();
	document.cookie = name + "=mc" + expires + "; path=/";
}

// Sets Cookie
export function setCookie(name, value) {
	document.cookie = `${name}=${value}; path=/`;
}

// Remove from array of items the one listed with category: IGNORE
export function removeIgnoreItems(arr) {
	let newArr = arr.item.filter((el)=> {
		return el.category !== "IGNORE";
	});
	return newArr;
}

// Returns an object with formatted date parts using an utc date and return it in specified timezone
export function formatDate(studioDate, timezone) {
    const clientTimezone = timezone ? moment.tz(studioDate, timezone) : moment.tz(studioDate, moment.tz.guess());
    const date = new Date(studioDate);
    const dateFormatted = {
        month: moment(date).format('MMM'),
        weekDay: moment(date).format('dddd'),
        monthDay: moment(date).format('Do'),
        year: moment(date).format('YYYY'),
        time: moment(date).format('LT'),
        timezone: clientTimezone.format('z'),
        dateObj: date,
        momentObj: clientTimezone,
        calendar: moment(date).calendar()
	};
    return dateFormatted;
}

export function formatLocalDate(studioDate, timezone) {
	const studioTimeZone = timezone ?
	moment.tz(studioDate, timezone) : moment.tz(studioDate, moment.tz.guess());
	const clientTimezone = timezone ? 
	moment.tz(studioTimeZone, moment.tz.guess()) : studioTimeZone;
  
	return clientTimezone;
}
  
export const currentFormatDate = (timezone) => {
	const tz = timezone ? timezone : moment.tz.guess();

	return moment.tz(tz);
};

// Returns label FR or EN based on key & language on Cookie
export const getLabel = (key)=> {
	const langlabel = `${key}_${getLanguage()}`;
	const jsonMulti = require('./multilingual.json');

	return jsonMulti[langlabel];
}

// Returns new url that matchs by url & language based on the URLMap obj in the redux store
export const getNewUrl = (urlMap, url, params, currentLanguage = "en") => {
	const objUrl = urlMap[currentLanguage];

    if (objUrl[url] && objUrl[url].length > 0) {
		if(params !== "" && params !== undefined) {
			return objUrl[url]+params;
		}
        return objUrl[url];
	}
	
    return url;
}

// Convert Date to Specified Timezone 
export const convertToTimeZone = (curDate,timezone) => {
	const newDate = moment(new Date(curDate.date));
	const tmpDate = newDate.clone().tz(timezone);

	return tmpDate.format(); 
}
// Convert Date to Local Timezone
export const convertToLocalTimeZone = (curDate) => {
	const newDate = moment(new Date(curDate.date));
	const tmpDate = newDate.clone().tz(moment.tz.guess());

	return tmpDate.format();
}

export const setImgSrcSize = (imgSrc , size) => {
    if(imgSrc !== undefined) {
		const lastDot = imgSrc.lastIndexOf(".");
		const start = imgSrc.substring(0, lastDot)
		const end = imgSrc.substring(lastDot+1)
		let result
		if (start.startsWith("http")) {
			result = `${start}_${size}.${end}`
		} else {
			const configT = crafterConf.getConfig()
			result = composeUrl(configT , `${start}_${size}.${end}?crafterSite=${configT.site}`);
		}
		// console.log("setImgSrcSize", {
		// 	imgSrc: imgSrc,
		// 	size: size,
		// 	result: result
		// })
		return result
    }
}

//function to validate the size of the incoming string also return the small version of the description
export const validateTextSize = (text, size) => {
	const temp = text.split('');
	let result = temp.filter((el, i) => i <= (size - 1));

	return result.join("");
}

export const truncateWords = (characters, length) => {
	if (length >= characters.length) return characters;
  
	let oldResult = /\s/.test(characters.charAt(length));
	for (let i = length - 1; i > -1; i--) {
	  const currentResult = /\s/.test(characters.charAt(i))
	  if (oldResult && !currentResult) {
		return `${characters.substr(0, i + 1)}`;
	  }
	  oldResult = currentResult;
	}
	return '(...)';
}

//function to check elements on for tab on modals
export const handleTabKey = (e, ref) => {
	const focusableModalElements = ref.current.querySelectorAll(
		'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], p'
	);
	const firstElement = focusableModalElements[0];
	const lastElement =
	focusableModalElements[focusableModalElements.length - 1];

	if (!e.shiftKey && document.activeElement !== firstElement && document.activeElement === lastElement) {
		firstElement.focus();
		return e.preventDefault();
	}
	if (e.shiftKey && document.activeElement !== lastElement && document.activeElement === firstElement) {
		lastElement.focus();
		e.preventDefault();
	}
};

export const resizeHandler = elems => {
    document.querySelectorAll(elems).forEach((element) => {
        const elementWidth = element.clientWidth;
        element.style.setProperty('--aspect-ratio-image-width', `${elementWidth}px`);
    });
}

//const curDate = {date:"2021-02-16T05:00:00.000Z"};

//Example how to invoque convertToTimezone = convertToTimeZone(curDate,"Australia/Sydney"));
//Example how to invoque convertToLocalTimeZone = convertToTimeZone(curDate);

/**
 * Use a smaller version of the specified image.  Requires the image format to
 * be /a/path/of/unspecified/length/the_file.some_ext_like_png.
 * @param imagePath the original image path.  If null is passed, null is returned.
 * @param size (one of "sm", "md", "lg", "full")
 * @returns {string|*} the path to the resized image, or the small version if a
 * resized image cannot be computed (or the original image if the user specified "full").  Note this
 * function does not verify that the image exists it just assumes that it is there.
 */
export const smallerImage = (imagePath, size) => {
	if (!imagePath) {
		console.error("Null image path not allowed.")
		return imagePath
	}
	if (size === "full") return imagePath
	if (!size) size = "sm"	
	if (size === "sm" || size === "md" || size === "lg") {
		const lastDot = imagePath.lastIndexOf('.')
		if (lastDot >= 0 && lastDot < imagePath.length) {
			const base = imagePath.substring(0,lastDot)
			const ext = imagePath.substring(lastDot+1)
			return base+"_"+size+"."+ext;
		} else {
			console.error("Invalid file path - it does not contain a dot - for image '"+imagePath+"'. Cannot determine smaller image path. Returning original image.")
			return imagePath
		}
	} else {
		console.error("Invalid image file size '"+size+"' specified for image '"+imagePath+"'. One of 'sm', 'md', 'lg' or 'full' must be specified. Returning original image.")
		return imagePath
	}

}

export const normalizeForSearch = (text) => {
	return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}